import { useCallback, useEffect, useState } from 'react';
import { Row } from '@guestyci/foundation/Layout';
import createStyles from '@guestyci/foundation/createStyles';
import RaisedButton from '@guestyci/foundation/RaisedButton';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import useDrag from 'app/shareable/hooks/useDrag';

const useStyles = createStyles((theme: typeof defaultTheme) => {
  return {
    root: (props: { visible: boolean }) => {
      return {
        position: 'fixed',
        bottom: 48,
        right: 16,
        zIndex: theme.zIndex.appBar,
        color: theme.palette.primary.default,
        background: theme.palette.background.white,
        borderRadius: '26px 12px 12px 26px',
        opacity: props.visible ? 1 : 0,
        padding: 3,
        paddingRight: 0,
        fontSize: 18,
        filter: 'drop-shadow(0 0 2px rgba(22, 45, 61, 0.36))',
        alignItems: 'stretch',
        userSelect: 'none',
        transition: 'opacity .2s',
      };
    },
    helpBtn: {
      borderRadius: '50%',
      width: 46,
      height: 46,
      fontFamily: 'sans-serif',
      minWidth: 'auto',
      fontSize: 32,
      fontWeight: 'bold',
    },
    dragItem: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'move',
      padding: 3,
    },
  };
});

const ZendeskLauncher = () => {
  const [visible, setVisible] = useState(true);
  const classes = useStyles({ visible });

  const [draggable, isDrugging] = useDrag();

  const webWidget = (command: string) => {
    window?.zE('webWidget', command);
  };

  useEffect(() => {
    webWidget('hide');

    window?.zE('webWidget:on', 'close', () => {
      webWidget('hide');
      setVisible(true);
    });
  }, []);

  const handleClick = useCallback(() => {
    if (isDrugging) return;

    webWidget('show');
    webWidget('open');

    setVisible(false);
  }, [isDrugging]);

  return (
    <>
      <Row
        ref={draggable}
        className={classes.root}
        align="center"
        justify="around"
      >
        <RaisedButton
          size="lg"
          title="Need help?"
          className={classes.helpBtn}
          onClick={handleClick}
        >
          ?
        </RaisedButton>
        <div className={classes.dragItem}>&#8942;</div>
      </Row>
    </>
  );
};

ZendeskLauncher.displayName = 'ZendeskLauncher';

export default ZendeskLauncher;
